import {rpAppLink} from "@pg-mono/rp-routes";

import {IRcnAddressKey} from "../types/IRcnAddress";

export const getAddressLink = ({city, street, number}: IRcnAddressKey) => {
    // RCN requires the original address values. Split the raw path segment on hyphens before decoding each value on the destination page.
    const addressPath = [city, street, number].map((part) => encodeURIComponent(part).replace(/-/g, "%2D")).join("-");

    return `${rpAppLink.prices.flats.base()}${addressPath}/`;
};
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRcnAddressKey} from "../types/IRcnAddress";

export const getAddressLink = ({city, street, number}: IRcnAddressKey) => {
    // RCN requires the original address values. Split the raw path segment on hyphens before decoding each value on the destination page.
    const addressPath = [city, street, number].map((part) => encodeURIComponent(part).replace(/-/g, "%2D")).join("-");

    return `${rpAppLink.prices.flats.base()}${addressPath}/`;
};
